export const componentType = {
  Input: 'Input',
  Select: 'Select',
  DatePicker: 'DatePicker',
  Radio: 'Radio',
  RadioGroup: 'RadioGroup',
  Checkbox: 'Checkbox',
  CheckboxGroup: 'CheckboxGroup',
  Magnifier: 'Magnifier'
};
